import styles from './PopperUserInfo.module.scss';
import classNames from 'classnames/bind';
import {useState} from "react";
import Tippy from '@tippyjs/react/headless';
import {
	PopperWrapper
} from "../Popper";
import {
	Image,
	StatusLabel
} from "~/components";
import {arrayToMap} from "~/utils";
import {useGroup} from "../../hooks";
import {Tag} from "antd";
const cn = classNames.bind(styles);
function PopperUserInfo({children, user})
{
	const listGroup = useGroup();

	const groupMap = arrayToMap(listGroup);

	const [showActionBox, setShowActionBox] = useState(false);

	const closeActionButton = () => {
		setShowActionBox(false);
	};

	const renderActionButton = () => {
		return (
			<PopperWrapper className="action-wrapper" style={{minWidth: '320px', }}>
				<div className={cn("account-heading")}>
					<div className={cn("account-info")}>
						<div className="d-flex gap align-items justify-content-between">
							<div className={cn('avatar')+' avatar'}><Image src={user?.avatar} /></div>
							<div>
								<b>{user?.firstname + ' ' + user?.lastname}</b>
								<p><Tag color={user?.company.badge}>{user?.company.label}</Tag> {user?.username}</p>
							</div>
							<div>
								<StatusLabel small type={user?.status?.badge}>{user?.status?.label}</StatusLabel>
							</div>
						</div>
					</div>
					<hr />
					<div className={cn("account-group")}>
						<p className="mb-1">{user?.email}</p>
						<StatusLabel small type={user?.role?.badge}>{user.role?.label}</StatusLabel>
						<p className="mt-1"><b>{(user?.group !== 0) ? groupMap[user?.group]?.name : user?.role?.label}</b></p>
					</div>
				</div>
			</PopperWrapper>
		)
	}

	return (
		<Tippy
			interactive
			visible={showActionBox}
			render={renderActionButton}
			onClickOutside={closeActionButton}
			placement="top"
			offset={[0, -10]}
		><span className={cn("box")} onClick={() => setShowActionBox(true)}>{children}</span></Tippy>
	)
}

export default PopperUserInfo;